import { forwardRef } from 'react';

import { Droppable } from '@hello-pangea/dnd';

import NotFound from 'components/practice/Dashboard/components/NotFound';
import Icon from 'components/shared/Icon/Icon';
import Spinner from 'components/shared/spinner/spinner';

import SpecialtyItem from './SpecialtyItem';

const SpecialtyList = forwardRef(
  (
    {
      droppableId,
      specialties,
      onAction,
      actionIcon,
      actionColor,
      emptyMessage,
      draggableIdPrefix = '',
      isLoading = false,
      isFetchingNextPage = false,
      onScroll,
      isError
    },
    ref
  ) => {
    if (isLoading) {
      return (
        <div className="flex flex-1 flex-col items-center justify-center overflow-y-auto">
          <Spinner wrapperStyle={{}} />
        </div>
      );
    }

    if (isError) {
      return (
        <div className="flex flex-1 flex-col items-center justify-center overflow-y-auto">
          <Icon icon="warning" className="mb-2 text-neutral-400" />
          <span className="text-sm text-neutral-500">Error loading specialties.</span>
        </div>
      );
    }

    return (
      <Droppable droppableId={droppableId}>
        {(provided, snapshot) => (
          <div
            ref={(node) => {
              provided.innerRef(node);
              // Handle both callback and object refs
              if (typeof ref === 'function') {
                ref(node);
              } else if (ref) {
                ref.current = node;
              }
            }}
            {...provided.droppableProps}
            onScroll={onScroll}
            className={`flex flex-1 flex-col overflow-y-auto ${snapshot.isDraggingOver ? 'bg-primary-50' : ''}`}>
            {specialties?.length > 0 ? (
              specialties.map((s, index) => (
                <SpecialtyItem
                  key={s.value}
                  specialty={s}
                  index={index}
                  onAction={onAction}
                  actionIcon={actionIcon}
                  actionColor={actionColor}
                  draggableIdPrefix={draggableIdPrefix}
                />
              ))
            ) : (
              <div className="flex h-full items-center justify-center">
                <NotFound
                  icon="illustration-no-content"
                  title={emptyMessage}
                  titleClassName="!text-neutral-900 !text-base !font-500 !leading-6"
                  description="Add billing specialties from the left panel."
                />
              </div>
            )}
            {isFetchingNextPage && (
              <div className="flex items-center justify-center py-2">
                <Icon icon="loader" className="animate-spin" />
              </div>
            )}
            <div className="hidden">{provided.placeholder}</div>
          </div>
        )}
      </Droppable>
    );
  }
);

SpecialtyList.displayName = 'SpecialtyList';

export default SpecialtyList;
